import { Injectable } from '@angular/core';
import { Store, guid } from '@datorama/akita';

export interface CoachSettingsState {
	activeTabIndex: number;
}

@Injectable()
export class CoachSettingsStore extends Store<CoachSettingsState> {
	constructor() {
		super({ activeTabIndex: 0 }, { name: `ui-coach-settings-${guid()}` });
	}
}
